t = require('views/internal/teacup-with-helpers')('popover_change_set_password')

module.exports = ->
  t.form ->

    t.mustacheBlock 'hasPassword', ->
      t.label { for: 'o_password' }, ->
        t.format 'old-password'
      t.input { id: 'o_password', type: 'password', name: 'oldpassword', value: '' }

    t.label { for: 'password1' }, ->
      t.mustacheBlock 'hasPassword', ->
        t.format 'new-password'
      t.mustacheBlockInverted 'hasPassword', ->
        t.format 'password'
    t.input { id: 'password1', type: 'password', name: 'password', value: '' }

    t.label { for: 'password2' }, ->
      t.mustacheBlock 'hasPassword', ->
        t.format 'new-password-again'
      t.mustacheBlockInverted 'hasPassword', ->
        t.format 'password-again'
    t.input { id: 'password2', type: 'password', name: 'password2', value: '' }

    t.p '.error', { id: 'password-error' }

    t.input '.primary.js-save-changes', { type: 'submit', value: t.l('save') }

  t.mustacheBlockInverted 'hasPassword', ->
    t.hr()

    t.p '.quiet.u-bottom', ->
      t.format 'you-havent-set-a-password-yet-you-can-set-a-password-so-you-can-log-onto-trello-with-just-your-username-or-email-address'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_change_set_password.coffee